import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import { env } from '~/commons/config';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormAdmin from '../../forms/FormAdmin.jsx';

const PageSchoolAdmin = () => {
  const { _id, adminId } = useParams();
  const [schoolRes, schoolReq] = useHttpStatus();
  const [adminRes, adminReq] = useHttpStatus();

  useEffect(() => {
    schoolReq({ url: `api/core/schools/${_id}` });

    if (adminId !== 'new') {
      adminReq({ url: `api/core/users/admins/${adminId}` });
    }
  }, [_id, adminId]);

  const res = [schoolRes];

  if (adminId !== 'new') {
    res.push(adminRes);
  }

  return (
    <PageHttp res={res}>
      {([school, admin]) => {
        const breadcrumb = [
          { to: '../../../', children: 'Schools' },
          { to: '../../', children: school.title.en || school.title.zhhk },
        ];

        return adminId === 'new' ? (
          <>
            <Header breadcrumb={breadcrumb}>New School Admin</Header>
            <FormAdmin school={school} />
          </>
        ) : (
          <>
            <Header breadcrumb={breadcrumb}>Edit School Admin</Header>
            <FormAdmin
              school={school}
              admin={admin}
            />
          </>
        );
      }}
    </PageHttp>
  );
};

export default PageSchoolAdmin;
